export function isAdmin(email?: string | null): email is string {
  return !!email && email.endsWith('@blumint.io');
}
